import { Box, Stack, useMediaQuery } from '@chakra-ui/react';
import type React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { ProfileHamburgerIcon } from '@/assets/icons';
import NotificationBell from '@/assets/icons/NotificationBell';
import FaceliftAvatar from '@/components/Atoms/FaceliftAvatar/FaceliftAvatar';
import FaceliftIconButton from '@/components/Atoms/FaceliftIconButton';
import NotificationsList from '@/components/Molecules/NotificationsList/NotificationsList';
import { ProfileMenu } from '@/components/Molecules/ProfileMenu';
import { colors } from '@/components/ui/theme';

const getInitials = (fullName: string) => {
	if (!fullName) return '';
	const parts = fullName.trim().split(/\s+/);
	if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
	return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
};

const TopbarSettings: React.FC<{ name?: string; previewUrl?: string; hideAvatar?: boolean }> = ({
	name = 'Demo User',
	previewUrl,
	hideAvatar = false,
}) => {
	const [showUserMenu, setShowUserMenu] = useState(false);
	const [showNotificationsList, setShowNotificationsList] = useState(false);
	const navigate = useNavigate();
	const [isSmallScreen] = useMediaQuery(['(max-width: 600px)']);

	return (
		<Stack direction={'row'} gap={isSmallScreen ? 1 : 4}>
			<NotificationsList
				trigger={
					<FaceliftIconButton
						aria-label="profile menu"
						bg="transparent"
						color="inherit"
						borderRadius="full"
						_hover={{
							bg: colors.hoverBg,
							transition: 'opacity 0.2s ease-in-out',
						}}
						css={{
							'& svg': {
								width: '20px !important',
								height: '22px !important',
							},
						}}
					>
						<NotificationBell color="white" />
					</FaceliftIconButton>
				}
				isOpen={showNotificationsList}
				onOpenChange={setShowNotificationsList}
			/>

			{!hideAvatar && (
				<Box
					cursor="pointer"
					onClick={() => navigate('/profile')}
					_hover={{ opacity: 0.8 }}
					transition="opacity 0.2s ease-in-out"
				>
					<FaceliftAvatar size="sm" name={getInitials(name)} previewUrl={previewUrl || ''} />
				</Box>
			)}

			{/* Profile menu using custom ProfileMenu */}
			<ProfileMenu
				trigger={
					<FaceliftIconButton
						aria-label="profile menu"
						bg="transparent"
						color="inherit"
						borderRadius="8px"
						css={{
							'& svg': {
								width: '32px !important',
								height: '32px !important',
							},
						}}
					>
						<ProfileHamburgerIcon width={27} height={25} />
					</FaceliftIconButton>
				}
				isOpen={showUserMenu}
				onOpenChange={setShowUserMenu}
				onNavigate={(href) => {
					if (href) {
						navigate(href);
					}
				}}
			/>
		</Stack>
	);
};

export default TopbarSettings;
